import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { Onglets } from '@components/onglets/models';
import { GenerateRangePipe } from '@shared/pipe';
import { SvgComponent } from '@shared/components/svg';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-onglets',
  imports: [GenerateRangePipe, SvgComponent, TranslatePipe, RouterLink],
  templateUrl: './onglets.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OngletsComponent extends AbstractDynamicComponent<Onglets> {}
